import { Cross2Icon } from '@radix-ui/react-icons'
import { Warning2 } from 'iconsax-react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import {
  ResponsiveModal,
  ResponsiveModalClose,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
} from '@/components/ResponsiveModal/ResponsiveModal'
import { Button } from '@/components/ui/button'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

export const DisclaimerPopUp = () => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const comesFromSocialMediaProfile = state.fromSocialMediaProfile
  const [open, setOpen] = useState<boolean>(!comesFromSocialMediaProfile)

  return (
    <ResponsiveModal open={open} onOpenChange={setOpen}>
      <ResponsiveModalContent className="max-w-3xl bg-baseColor p-6 flex flex-col gap-3">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row gap-2 items-center">
            <Warning2
              size="24"
              color={SocialMirrorPalette.dynamicRed}
              variant="Bold"
            />
            <ResponsiveModalTitle className="font-medium text-3xl">
              {t('report.generalInfo.disclaimer.title')}
            </ResponsiveModalTitle>
          </div>

          <ResponsiveModalClose
            className="max-md:hidden"
            children={
              <Button
                variant={'ghost'}
                className="rounded-full h-min w-min p-1"
              >
                <Cross2Icon
                  className="h-5 w-5"
                  color={SocialMirrorPalette.neutralColor}
                />
              </Button>
            }
          />
        </div>
        <ResponsiveModalDescription className="flex flex-col gap-4 w-full h-full max-md:justify-between">
          <div className="flex flex-col gap-4">
            <p className="font-bold text-xl text-neutralColor">
              {t('report.generalInfo.disclaimer.description')}
            </p>
            <p className="text-neutralColor text-xl font-normal">
              {t('report.generalInfo.disclaimer.description2')}
            </p>
          </div>
          <div className="flex justify-end w-full">
            <Button onClick={() => setOpen(false)}>
              {t('common.understood')}
            </Button>
          </div>
        </ResponsiveModalDescription>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
